export default "__VITE_ASSET__BTATIXgS__"